<template>
    <el-card>
        <el-row class="lucky-gift__title">幸运礼物V3配置管理</el-row>
        <!-- 搜索 -->
        <el-row class="lucky-gift__search">
            <div class="item">
                <span>渠道:</span>
                <el-select v-model="searchList.channel" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in channelList" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>子奖池:</span>
                <el-select v-model="searchList.sonPool" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in sonPoolList" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>标签:</span>
                <el-select v-model="searchList.label" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in labelList" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>有效状态:</span>
                <el-select v-model="searchList.valid" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in validList" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-button type="primary" @click="getLuckyGiftList(1)">搜索</el-button>
            <el-button type="success" @click="() => {
                addDialogVisible = true
                addDialogType = 0
            }">添加</el-button>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="luckyGiftList">
                <el-table-column prop="id" label="ID" align="center" width="80">
                </el-table-column>
                <el-table-column prop="channel" label="渠道" align="center" width="120">
                    <template slot-scope="scope">
                        {{channelList.find(item => item.value == scope.row.channel)?.name || scope.row.channel}}
                    </template>
                </el-table-column>
                <el-table-column prop="sonPool" label="子奖池" align="center" width="120">
                    <template slot-scope="scope">
                        {{sonPoolList.find(item => item.value == scope.row.sonPool)?.name || scope.row.sonPool}}
                    </template>
                </el-table-column>
                <el-table-column prop="label" label="标签" align="center" width="120">
                    <template slot-scope="scope">
                        {{labelList.find(item => item.value == scope.row.label)?.name || scope.row.label}}
                    </template>
                </el-table-column>
                <el-table-column prop="jackpotBalance" label="Jackpot奖池余额" align="center" width="150">
                </el-table-column>
                <el-table-column prop="poolBalance" label="游戏奖池余额" align="center" width="150">
                </el-table-column>
                <el-table-column prop="valid" label="有效状态" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.valid == 0 ? 'danger' : 'success'" size="small">
                            {{ scope.row.valid == 0 ? '无效' : '有效' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="操作人" align="center" width="120">
                </el-table-column>
                <el-table-column prop="mtime" :formatter="formatTime" label="修改时间" align="center" width="150">
                </el-table-column>
                <el-table-column prop="ctime" :formatter="formatTime" label="创建时间" align="center" width="150">
                </el-table-column>
                <el-table-column label="操作" align="center" width="250">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="updateDialog(scope.row)"
                            style="margin-bottom: 10px;">编辑</el-button>
                        <el-button type="success" @click="copyDialog(scope.row)"
                            style="margin-bottom: 10px;">复制</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit"
                @current-change="handleCurrentChange">
            </el-pagination>
        </el-row>
        <!-- 添加/编辑 -->
        <el-dialog :title="addDialogType == 0 ? '添加幸运礼物V3配置' : '编辑幸运礼物V3配置'" :visible.sync="addDialogVisible" width="90%"
            @close="addDialogClose">
            <el-form :model="addDialogInfo" :rules="ruleList" ref="addDialogForm" label-width="150px">
                <!-- 基础信息 -->
                <el-card class="form-section" shadow="never">
                    <div slot="header" class="section-header">
                        <span>基础信息</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="渠道" prop="channel">
                                <el-select v-model="addDialogInfo.channel" filterable placeholder="请选择" style="width: 100%;" :disabled="addDialogType === 1">
                                    <el-option v-for="(item, index) in channelList" :key="index" :label="item.name"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="子奖池" prop="sonPool">
                                <el-select v-model="addDialogInfo.sonPool" filterable placeholder="请选择" style="width: 100%;" :disabled="addDialogType === 1">
                                    <el-option v-for="(item, index) in sonPoolList" :key="index" :label="item.name"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="标签" prop="label">
                                <el-select v-model="addDialogInfo.label" filterable placeholder="请选择" style="width: 100%;" :disabled="addDialogType === 1">
                                    <el-option v-for="(item, index) in labelList" :key="index" :label="item.name"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="有效状态" prop="valid">
                                <el-switch v-model="addDialogInfo.valid" :active-value="1" :inactive-value="0" active-text="有效"
                                    inactive-text="无效"></el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>

                <!-- 分成配置 -->
                <el-card class="form-section" shadow="never">
                    <div slot="header" class="section-header">
                        <span>分成配置</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="系统回收比例" prop="splitConfig.system">
                                <el-input v-model="addDialogInfo.splitConfig.system" placeholder="万分率，如0.03%输入3">
                                    <template slot="append">万分率</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="主播分成比例" prop="splitConfig.host">
                                <el-input v-model="addDialogInfo.splitConfig.host" placeholder="请输入主播分成比例">
                                    <template slot="append">万分率</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="Jackpot奖池比例" prop="splitConfig.jackpotPool">
                                <el-input v-model="addDialogInfo.splitConfig.jackpotPool" placeholder="请输入Jackpot奖池比例">
                                    <template slot="append">万分率</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="游戏奖池比例" prop="splitConfig.pool">
                                <el-input v-model="addDialogInfo.splitConfig.pool" placeholder="请输入游戏奖池比例">
                                    <template slot="append">万分率</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 隐藏指定礼物ID列表 -->
                    <!-- <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="指定礼物ID列表" prop="splitConfig.giftIds">
                                <el-input v-model="giftIdsInput" placeholder="请输入礼物ID，多个用逗号分隔" @blur="parseGiftIds">
                                    <template slot="prepend">礼物ID</template>
                                </el-input>
                                <div style="font-size: 12px; color: #999; margin-top: 5px;">
                                    例如：1001,1002,1003
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                </el-card>

                <!-- Jackpot配置 -->
                <el-card class="form-section" shadow="never">
                    <div slot="header" class="section-header">
                        <span>Jackpot奖池配置</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="每日最小抽奖次数" prop="jackpotConfig.dailyMinDrawTimes">
                                <el-input-number v-model="addDialogInfo.jackpotConfig.dailyMinDrawTimes" :min="0" placeholder="请输入每日最小抽奖次数" style="width: 100%;"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="最近30天最小充值金币数" prop="jackpotConfig.lastMonthMinRechargeCoins">
                                <el-input-number v-model="addDialogInfo.jackpotConfig.lastMonthMinRechargeCoins" :min="0" placeholder="请输入最近30天最小充值金币数" style="width: 100%;"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="返奖倍率配置">
                                <div style="margin-bottom: 10px;">
                                    <el-button type="primary" size="small" @click="addMultiConfig('jackpot')">添加倍率配置</el-button>
                                    <span style="margin-left: 10px; color: #666; font-size: 12px;">配置Jackpot奖池的返奖倍率和概率</span>
                                </div>
                                <el-table :data="addDialogInfo.jackpotConfig.multiConfigList" style="margin-top: 10px;" size="mini" border>
                                    <el-table-column prop="multi" label="返奖倍数" width="120">
                                        <template slot-scope="scope">
                                            <el-input-number v-model="scope.row.multi" :min="0" size="mini" style="width: 100%;"></el-input-number>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="rate" label="个数" width="120">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.rate" placeholder="个数" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="80">
                                        <template slot-scope="scope">
                                            <el-button type="danger" size="mini" @click="removeMultiConfig('jackpot', scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>

                <!-- 游戏奖池配置 -->
                <el-card class="form-section" shadow="never">
                    <div slot="header" class="section-header">
                        <span>游戏奖池配置</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="奖池上限值" prop="poolConfig.maxLimit">
                                <el-input v-model="addDialogInfo.poolConfig.maxLimit" placeholder="请输入奖池上限值"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="达上限触发概率" prop="poolConfig.maxRate">
                                <el-input v-model="addDialogInfo.poolConfig.maxRate" placeholder="万分率">
                                    <template slot="append">万分率</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="奖池下限值" prop="poolConfig.minLimit">
                                <el-input v-model="addDialogInfo.poolConfig.minLimit" placeholder="请输入奖池下限值"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="达下限触发概率" prop="poolConfig.minRate">
                                <el-input v-model="addDialogInfo.poolConfig.minRate" placeholder="万分率">
                                    <template slot="append">万分率</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 使用折叠面板组织各种奖池配置 -->
                    <el-collapse v-model="activeCollapse" style="margin-top: 20px;">
                        <!-- 普通奖池配置 -->
                        <el-collapse-item title="普通奖池配置" name="pool">
                            <div style="margin-bottom: 10px;">
                                <el-button type="primary" size="small" @click="addMultiConfig('pool')">添加倍率配置</el-button>
                            </div>
                            <el-table :data="addDialogInfo.poolConfig.poolMultiList" size="mini" border>
                                <el-table-column prop="multi" label="返奖倍数" width="120">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.multi" :min="0" size="mini" style="width: 100%;"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="rate" label="个数" width="120">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.rate" placeholder="个数" size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="mini" @click="removeMultiConfig('pool', scope.$index)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-collapse-item>

                        <!-- 放水奖池配置 -->
                        <el-collapse-item title="放水奖池配置" name="waterproof">
                            <div style="margin-bottom: 10px;">
                                <el-button type="primary" size="small" @click="addMultiConfig('waterproof')">添加倍率配置</el-button>
                            </div>
                            <el-table :data="addDialogInfo.poolConfig.waterproofMultiList" size="mini" border>
                                <el-table-column prop="multi" label="返奖倍数" width="120">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.multi" :min="0" size="mini" style="width: 100%;"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="rate" label="个数" width="120">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.rate" placeholder="个数" size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="mini" @click="removeMultiConfig('waterproof', scope.$index)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-collapse-item>

                        <!-- 回收奖池配置 -->
                        <el-collapse-item title="回收奖池配置" name="recycle">
                            <div style="margin-bottom: 10px;">
                                <el-button type="primary" size="small" @click="addMultiConfig('recycle')">添加倍率配置</el-button>
                            </div>
                            <el-table :data="addDialogInfo.poolConfig.recycleMultiList" size="mini" border>
                                <el-table-column prop="multi" label="返奖倍数" width="120">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.multi" :min="0" size="mini" style="width: 100%;"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="rate" label="个数" width="120">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.rate" placeholder="个数" size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="mini" @click="removeMultiConfig('recycle', scope.$index)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-collapse-item>

                        <!-- 通杀奖池配置 -->
                        <el-collapse-item title="通杀奖池配置" name="kill">
                            <div style="margin-bottom: 10px;">
                                <el-button type="primary" size="small" @click="addMultiConfig('kill')">添加倍率配置</el-button>
                            </div>
                            <el-table :data="addDialogInfo.poolConfig.killMultiList" size="mini" border>
                                <el-table-column prop="multi" label="返奖倍数" width="120">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.multi" :min="0" size="mini" style="width: 100%;"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="rate" label="个数" width="120">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.rate" placeholder="个数" size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="mini" @click="removeMultiConfig('kill', scope.$index)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-collapse-item>
                    </el-collapse>
                </el-card>

                <!-- 奖池余额 -->
                <el-card class="form-section" shadow="never">
                    <div slot="header" class="section-header">
                        <span>奖池余额</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Jackpot奖池初始数值" prop="jackpotBalance">
                                <el-input v-model="addDialogInfo.jackpotBalance" 
                                    placeholder="请输入Jackpot奖池初始数值"
                                    :disabled="addDialogType === 1">
                                    <template slot="prepend">Jackpot</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="游戏奖池初始数值" prop="poolBalance">
                                <el-input v-model="addDialogInfo.poolBalance" 
                                    placeholder="请输入游戏奖池初始数值"
                                    :disabled="addDialogType === 1">
                                    <template slot="prepend">游戏奖池</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>
            </el-form>
            
            <!-- 操作按钮 -->
            <div style="text-align: right; margin-top: 20px;">
                <el-button @click="addDialogClose">取消</el-button>
                <el-button type="primary" @click="submitDialog">确定</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>
<script>
import { getConstList } from '@/api/constRequest'

export default {
    name: 'LuckyGiftV3',
    data() {
        return {
            searchList: {
                channel: null,
                sonPool: null,
                label: null,
                valid: 1,
            },
            // 0:添加 1:编辑
            addDialogType: 0,
            addDialogVisible: false,
            validList: [
                {
                    value: 0,
                    label: '无效'
                },
                {
                    value: 1,
                    label: '有效'
                }
            ],
            addDialogInfo: {
                id: null,
                channel: null,
                sonPool: null,
                label: null,
                splitConfig: {
                    system: '',
                    host: '',
                    jackpotPool: '',
                    pool: '',
                    giftIds: []
                },
                jackpotConfig: {
                    dailyMinDrawTimes: 0,
                    lastMonthMinRechargeCoins: 0,
                    multiConfigList: []
                },
                poolConfig: {
                    maxLimit: '',
                    maxRate: '',
                    minLimit: '',
                    minRate: '',
                    poolMultiList: [],
                    waterproofMultiList: [],
                    recycleMultiList: [],
                    killMultiList: []
                },
                jackpotBalance: '',
                poolBalance: '',
                valid: 1,
                operator: ''
            },
            ruleList: {
                'channel': [{ required: true, message: '请选择渠道', trigger: 'change' }],
                'sonPool': [{ required: true, message: '请选择子奖池', trigger: 'change' }],
                'label': [{ required: true, message: '请选择标签', trigger: 'change' }],
                'valid': [{ required: true, message: '请选择有效状态', trigger: 'change' }],
            },
            sonPoolList: [],
            labelList: [],
            channelList: [],
            luckyGiftList: [],
            total: 0,
            page: 1,
            limit: 20,
            giftIdsInput: '',
            activeCollapse: ['pool']
        }
    },
    mounted() {
        this.getSonPoolList()
        this.getLabelList()
        this.getChannelList()
        this.getLuckyGiftList(1)
    },
    methods: {
        formatTime(row, column, cellValue) {
            return cellValue ? new Date(cellValue * 1000).toLocaleString() : ''
        },
        async getSonPoolList() {
            const res = await getConstList('luckyGiftSonPool');
            if (res.code != 0) return this.$message.error(res.msg);
            this.sonPoolList = res.data.filter(item => item.value !== 0)
        },
        async getLabelList() {
            const res = await getConstList('luckyGiftLabel');
            if (res.code != 0) return this.$message.error(res.msg);
            this.labelList = res.data
        },
        async getChannelList() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url: this.$store.getters.path.channelList +
                    '?username=' +
                    this.$store.getters.username +
                    '&token=' +
                    this.$store.getters.token,
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.channelList = [
                    { channelId: -1, name: 'DEFAULT', value: 'DEFAULT' },
                    { channelId: -2, name: 'all', value: 'all' },
                    ...res.data,
                ]
            }
        },
        addDialogClose() {
            this.addDialogVisible = false
            this.activeCollapse = ['pool']
            this.addDialogInfo = {
                id: null,
                channel: null,
                sonPool: null,
                label: null,
                splitConfig: {
                    system: '',
                    host: '',
                    jackpotPool: '',
                    pool: '',
                    giftIds: []
                },
                jackpotConfig: {
                    dailyMinDrawTimes: 0,
                    lastMonthMinRechargeCoins: 0,
                    multiConfigList: []
                },
                poolConfig: {
                    maxLimit: '',
                    maxRate: '',
                    minLimit: '',
                    minRate: '',
                    poolMultiList: [],
                    waterproofMultiList: [],
                    recycleMultiList: [],
                    killMultiList: []
                },
                jackpotBalance: '',
                poolBalance: '',
                valid: 1,
                operator: ''
            }
            this.giftIdsInput = ''
        },
        submitDialog() {
            this.$refs.addDialogForm.validate((valid) => {
                if (valid) {
                    if (this.addDialogType == 0) {
                        this.addLuckyGift()
                    } else {
                        this.updateLuckyGift()
                    }
                }
            });
        },
        updateDialog(info) {
            this.addDialogType = 1
            this.addDialogInfo = JSON.parse(JSON.stringify(info))
            this.giftIdsInput = info.splitConfig.giftIds ? info.splitConfig.giftIds.join(',') : ''
            this.addDialogVisible = true
        },
        copyDialog(info) {
            this.addDialogType = 0
            // 深拷贝数据并去掉id
            this.addDialogInfo = JSON.parse(JSON.stringify(info))
            this.addDialogInfo.id = null
            this.giftIdsInput = info.splitConfig.giftIds ? info.splitConfig.giftIds.join(',') : ''
            this.addDialogVisible = true
        },
        handleCurrentChange(page) {
            this.getLuckyGiftList(page)
        },
        parseGiftIds() {
            if (this.giftIdsInput) {
                this.addDialogInfo.splitConfig.giftIds = this.giftIdsInput.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id))
            } else {
                this.addDialogInfo.splitConfig.giftIds = []
            }
        },
        addMultiConfig(type) {
            const config = { multi: 0, rate: '' }
            switch (type) {
                case 'jackpot':
                    this.addDialogInfo.jackpotConfig.multiConfigList.push(config)
                    break
                case 'pool':
                    this.addDialogInfo.poolConfig.poolMultiList.push(config)
                    break
                case 'waterproof':
                    this.addDialogInfo.poolConfig.waterproofMultiList.push(config)
                    break
                case 'recycle':
                    this.addDialogInfo.poolConfig.recycleMultiList.push(config)
                    break
                case 'kill':
                    this.addDialogInfo.poolConfig.killMultiList.push(config)
                    break
            }
        },
        removeMultiConfig(type, index) {
            switch (type) {
                case 'jackpot':
                    this.addDialogInfo.jackpotConfig.multiConfigList.splice(index, 1)
                    break
                case 'pool':
                    this.addDialogInfo.poolConfig.poolMultiList.splice(index, 1)
                    break
                case 'waterproof':
                    this.addDialogInfo.poolConfig.waterproofMultiList.splice(index, 1)
                    break
                case 'recycle':
                    this.addDialogInfo.poolConfig.recycleMultiList.splice(index, 1)
                    break
                case 'kill':
                    this.addDialogInfo.poolConfig.killMultiList.splice(index, 1)
                    break
            }
        },
        async getLuckyGiftList(page) {
            if (page) {
                this.page = page
            }
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.pool_mgr_lucky_gift_v3_list,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    pageNum: this.page,
                    pageSize: this.limit,
                    ...this.searchList
                }
            })
            if (res.code === 0 || res.status === 0) {
                console.log('API返回数据:', res.data)
                if (res.data && Array.isArray(res.data.data)) {
                    this.luckyGiftList = res.data.data
                    this.total = res.data.total || res.data.data.length
                } else {
                    this.luckyGiftList = []
                    this.total = 0
                }
                console.log('处理后的幸运礼物列表:', this.luckyGiftList)
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async addLuckyGift() {
            const data = JSON.parse(JSON.stringify(this.addDialogInfo))
            // 数据格式转换，确保符合API要求
            this.formatDataForApi(data)
            // 添加必要的字段
            data.operator = this.$store.getters.username
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.pool_mgr_lucky_gift_v3_create,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code === 0 || res.status === 0) {
                this.$message.success('添加成功')
                this.getLuckyGiftList()
                this.addDialogClose()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async updateLuckyGift() {
            const data = JSON.parse(JSON.stringify(this.addDialogInfo))
            // 数据格式转换，确保符合API要求
            this.formatDataForApi(data)
            // 添加必要的字段
            data.operator = this.$store.getters.username
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.pool_mgr_lucky_gift_v3_update,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code === 0 || res.status === 0) {
                this.$message.success('更新成功')
                this.getLuckyGiftList()
                this.addDialogClose()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        formatDataForApi(data) {
            // 确保数字字段为数字类型
            if (data.sonPool !== null && data.sonPool !== undefined) {
                data.sonPool = parseInt(data.sonPool)
            }
            if (data.jackpotConfig.dailyMinDrawTimes !== null && data.jackpotConfig.dailyMinDrawTimes !== undefined) {
                data.jackpotConfig.dailyMinDrawTimes = parseInt(data.jackpotConfig.dailyMinDrawTimes)
            }
            if (data.jackpotConfig.lastMonthMinRechargeCoins !== null && data.jackpotConfig.lastMonthMinRechargeCoins !== undefined) {
                data.jackpotConfig.lastMonthMinRechargeCoins = parseInt(data.jackpotConfig.lastMonthMinRechargeCoins)
            }
            
            // 确保字符串字段不为空字符串时转换为null
            const stringFields = [
                'splitConfig.system', 'splitConfig.host', 'splitConfig.jackpotPool', 'splitConfig.pool',
                'poolConfig.maxLimit', 'poolConfig.maxRate', 'poolConfig.minLimit', 'poolConfig.minRate',
                'jackpotBalance', 'poolBalance'
            ]
            
            stringFields.forEach(field => {
                const keys = field.split('.')
                let obj = data
                for (let i = 0; i < keys.length - 1; i++) {
                    obj = obj[keys[i]]
                }
                const lastKey = keys[keys.length - 1]
                if (obj[lastKey] === '') {
                    obj[lastKey] = null
                }
            })
            
            // 处理倍率配置中的数字字段
            const multiConfigFields = [
                'jackpotConfig.multiConfigList',
                'poolConfig.poolMultiList',
                'poolConfig.waterproofMultiList',
                'poolConfig.recycleMultiList',
                'poolConfig.killMultiList'
            ]
            
            multiConfigFields.forEach(field => {
                const keys = field.split('.')
                let obj = data
                for (let i = 0; i < keys.length - 1; i++) {
                    obj = obj[keys[i]]
                }
                const lastKey = keys[keys.length - 1]
                if (Array.isArray(obj[lastKey])) {
                    obj[lastKey].forEach(item => {
                        if (item.multi !== null && item.multi !== undefined) {
                            item.multi = parseInt(item.multi)
                        }
                        if (item.rate === '') {
                            item.rate = null
                        }
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="scss">
.lucky-gift {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 20px;

        .item {
            display: flex;
            align-items: center;
            width: max-content;
        }

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }
    }
}

.form-section {
    margin-bottom: 20px;
    
    .section-header {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
    }
}
</style>
